// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DropboxCircleFilledSvg from "@ant-design/icons-svg/es/asn/DropboxCircleFilled";
import AntdIcon from '../components/AntdIcon';

var DropboxCircleFilled = function DropboxCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DropboxCircleFilledSvg
  }));
};

DropboxCircleFilled.displayName = 'DropboxCircleFilled';
export default React.forwardRef(DropboxCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/DropboxCircleFilled.js
// module id = 997
// module chunks = 0